import React, { useState } from 'react';
import { User as UserIcon, Settings, LogOut } from 'lucide-react';
import { User as UserType } from '../../types';

interface UserMenuProps {
  user: UserType | null;
  onLogout: () => void;
  onOpenSettings: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({ user, onLogout, onOpenSettings }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);

  return (
    <div className="user-menu-container">
      <button 
        className="user-menu-button"
        onClick={() => setShowUserMenu(!showUserMenu)}
      >
        <UserIcon size={20} />
        <span>{user?.username || '用户'}</span>
      </button>
      
      {showUserMenu && (
        <div className="user-menu">
          <div className="user-menu-header">
            <div className="user-avatar">
              <UserIcon size={24} />
            </div>
            <div className="user-info">
              <span className="user-name">{user?.username || '用户'}</span>
              <span className="user-role">认证用户</span>
            </div>
          </div>
          <div className="user-menu-items">
            <button className="user-menu-item" onClick={() => { setShowUserMenu(false); onOpenSettings(); }}>
              <Settings size={16} />
              <span>设置</span>
            </button>
            <button className="user-menu-item" onClick={onLogout}>
              <LogOut size={16} />
              <span>退出登录</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
